import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';
import { SEARCH_HIDE, SEARCH_SHOW, SEARCH_TOGGLE, LISTING_COUNT_UPDATE } from '../js/events';
import {
    trans,

    LISTINGS_FILTER_SEARCH
} from '../translator';

export default class SearchButtonController extends Controller {
    static targets = [
        'backdrop',
        'container',
        'content',
        'searchBtn',
    ];

    static classes = [
        'backdropHide',
        'containerHide',
    ];


    /**
     * @returns {HTMLElement}
     */
    get backdrop() {
        return this.backdropTarget;
    }

    /**
     * @returns {HTMLElement}
     */
    get container() {
        return this.containerTarget;
    }

    /**
     * @returns {HTMLElement}
     */
    get content() {
        return this.contentTarget;
    }

    /**
     * @returns {HTMLElement|null}
     */
    get searchBtn() {
        return this.hasSearchBtnTarget ? this.searchBtnTarget : null;
    }

    connect() {
        useClickOutside(this, { element: this.content });

        window.addEventListener(SEARCH_HIDE, this.hide);
        window.addEventListener(SEARCH_SHOW, this.show);
        window.addEventListener(SEARCH_TOGGLE, this.toggle);
        window.addEventListener(LISTING_COUNT_UPDATE, this.listingCountUpdate);
    }

    disconnect() {
        window.removeEventListener(SEARCH_HIDE, this.hide);
        window.removeEventListener(SEARCH_SHOW, this.show);
        window.removeEventListener(SEARCH_TOGGLE, this.toggle);
        window.removeEventListener(LISTING_COUNT_UPDATE, this.listingCountUpdate);
    }

    clickOutside(event) {
        if (event.target.closest('.swal2-container')
            || event.target.closest('[data-modal-id]')
        ) {
            // don't close on overlays
            return;
        }

        if (this.searchBtn) {
            this.searchBtn.click();
        } else {
            this.hide();
        }
    }

    hide = () => {
        this.container.classList.add(...this.containerHideClasses);
        this.backdrop.classList.add(...this.backdropHideClasses);
    };

    show = () => {
        this.container.classList.remove(...this.containerHideClasses);
        this.backdrop.classList.remove(...this.backdropHideClasses);
    };

    toggle = () => {
        if (this.container.classList.contains(this.containerHideClass)) {
            this.show();
        } else {
            this.hide();
        }
    };

    listingCountUpdate = (e) => {
        if (!this.searchBtn) {
            return;
        }

        this.searchBtn.innerText = trans(LISTINGS_FILTER_SEARCH) + ` (${e.detail.listing_count})`;
    };
}
